import DownloadIcon from "assets/images/svg/download_dark.svg";
import { formatDate, json } from "helpers/data";

import { Button } from "components/form";
import { toast } from "react-toastify";
import _productService from "services/products-services";

import { useQueryClient } from "react-query";
import { useTranslation } from "react-i18next";
import CanLoadGuard from "components/private-route/can-load.guard";
import { useIP } from "hooks/use-products";

const ReleasesCard = ({ item: { id, releaseTitle, size, released, description, downloadUrl, canDownload }, className }) => {
  const { t } = useTranslation("browse-apps");
  const queryClinet = useQueryClient();
  const ip =useIP() 

  const handleDownload = () => {
    if (canDownload) {
      _productService.sendReleaseDownloadReq({ versionReleaseId: id, ipAddress: ip }).then(() => {
        window.open(downloadUrl, "_blank");
        queryClinet.refetchQueries("products-releases");
      });
    } else {
      toast.error(t('myProducts:resleasePage.sorryDownload'));
    }
  };

  return (
    <div className={`box-releases ${className}`}>
      <div className="releases-header">
        <h1 className="title">{releaseTitle}</h1>
        <CanLoadGuard>
          <Button className="download" onClick={() => handleDownload()}>
            <img src={DownloadIcon} alt="icon" />
            {t("myProducts.resleasePage.download")}
          </Button>
        </CanLoadGuard>
      </div>
      <div className="info">
        <p className="p-title">
          {t("myProducts.resleasePage.size")}: <span>{size}</span>
        </p>
        <p className="p-title">
          {t("myProducts.resleasePage.release")}: <span>{formatDate(released)}</span>
        </p>
      </div>
      <p className="content">{json(description)}</p>
    </div>
  );
};

export default ReleasesCard;
